import Footer from "@components/Footer/Footer";
import Header from "@components/Header/Header";
import useAppStore from "@hooks/useAppStore";
import i18n from "@i18n/i18n";
import { Box } from "@mui/material";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

const MainLayout = observer(() => {
  const appStore = useAppStore();

  useEffect(() => {
    // nada
  }, [appStore.colorMode, appStore.language]);

  return (
    <>
      {/*<Header message="CarbonIQ" />*/}
      <Header message={i18n.t("main.header")} />
      <Box sx={{ display: "flex", flexGrow: 1 }}>
        <Outlet />
      </Box>
      <Footer message={i18n.t("app.footer.title", { year: new Date().getFullYear() })} />
    </>
  );
});

export default MainLayout;
